<template>
    <data-table
        action-button-text="SLA جدید"
        action-button-icon="add"
        show-select
        remove-key="sla"
        export-key="sla"
        settings-key="sla"
        @click:actionButton="router.push({path: '/settings/sla/new' })"
        @getList="getList"
        :rowClick="(row) => router.resolve({path: `/settings/sla/${row.id}`})"
        :headers="headers"
        :items="items"
        :loading="loading"
        :totalItems="totalItems"
        :filters="filters"
        :getAllList="getAllList"
    >
        <template #item.importances="{value}">
            <span v-if="value.length == 0">-------</span>
            <span v-else-if="value.length == 1">{{ system.importances.find(x => x.id == value[0]).name }}</span>
            <v-menu v-else>
                <template #activator="{ props }">
                    <v-btn v-bind="props" icon="icon-ticketlevel" color="primary" variant="text"></v-btn>
                </template>
                <div class="py-3 px-8 bg-white elevation-1">
                    <p v-for="item in value" class="text-small text-secondary font-weight-bold my-2">{{ system.importances.find(x => x.id == item).name }}</p>
                </div>
            </v-menu>
        </template>
        <template #item.ticket_categories="{value, item}">
            <span v-if="value.length == 0 && !item.other_ticket_category">-------</span>
            <span v-else-if="(value.length == 1 && !item.other_ticket_category) || (value.length == 0 && item.other_ticket_category)">{{ item.other_ticket_category ? 'سایر' : value[0].name }}</span>
            <v-menu v-else>
                <template #activator="{ props }">
                    <v-btn v-bind="props" icon="icon-listticket" color="primary" variant="text"></v-btn>
                </template>
                <div class="py-3 px-8 bg-white elevation-1">
                    <p v-if="item.other_ticket_category" class="text-small text-secondary font-weight-bold my-2">سایر</p>
                    <p v-for="item in value" class="text-small text-secondary font-weight-bold my-2">{{ item.name }}</p>
                </div>
            </v-menu>
        </template>
        <template #item.customer_levels="{value}">
            <span v-if="value.length == 0">-------</span>
            <span v-else-if="value.length == 1">{{ value[0].name }}</span>
            <v-menu v-else>
                <template #activator="{ props }">
                    <v-btn v-bind="props" icon="icon-listticket" color="primary" variant="text"></v-btn>
                </template>
                <div class="py-3 px-8 bg-white elevation-1">
                    <p v-for="item in value" class="text-small text-secondary font-weight-bold my-2">{{ item.name }}</p>
                </div>
            </v-menu>
        </template>
        <template #item.workingshifts="{value}">
            <span v-if="value.length == 0">-------</span>
            <span v-else-if="value.length == 1">{{ value[0].name }}</span>
            <v-menu v-else>
                <template #activator="{ props }">
                    <v-btn v-bind="props" icon="icon-shitft" color="primary" variant="text"></v-btn>
                </template>
                <div class="py-3 px-8 bg-white elevation-1">
                    <p v-for="item in value" class="text-small text-secondary font-weight-bold my-2">{{ item.name }}</p>
                </div>
            </v-menu>
        </template>
    </data-table>
</template>
<script setup>
import { useApi } from '@/plugins/api';
import { useAuthStore } from '@/stores/auth';
import { useSystemStore } from '@/stores/system';
import { onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';

defineOptions({
    title: "قوانین SLA",
    validate(context) {
        return (context.auth.user.full_admin || context.auth.user.branch_admin) && context.system.license.features.ticket_sla;
    },
})
const api = useApi();
const router = useRouter();
const auth = useAuthStore();
const system = useSystemStore();
const loading = ref(false);
const items = ref([]);
const totalItems = ref(0);
const headers = ref([
    {
        title: 'عنوان',
        key: 'name',
        value: (item) => item.name,
        minWidth: 200,
    },
    {
        title: 'شعبه',
        key: 'branch',
        value: (item) => system.branches.find(x => x.id == item.branch_id)?.name,
        minWidth: 200,
        permission: auth.user.full_admin,
    },
    {
        title: 'دپارتمان',
        key: 'department',
        value: (item) => system.departmentsAdmin.length ? system.departmentsAdmin.find(x => x.id == item.department_id)?.name : undefined,
        minWidth: 200,
    },
    {
        title: 'شیفت‌های کاری',
        key: 'workingshifts',
        exportValue: (item) => item.workingshifts?.length ? item.workingshifts.map(x => x.name).join(', ') : undefined,
        minWidth: 160,
        filterable: false,
        sortable: false,
    },
    {
        title: 'دسته‌بندی‌های تیکت',
        key: 'ticket_categories',
        exportValue: (item) => item.ticket_categories?.length || item.other_ticket_category ? [...item.ticket_categories.map(x => x.name), item.other_ticket_category ? 'سایر' : false].filter('boolean').join(', ') : undefined,
        minWidth: 160,
        filterable: false,
        sortable: false,
    },
    {
        title: 'سطح مشتری',
        key: 'customer_levels',
        exportValue: (item) => item.customer_levels?.length ? item.customer_levels.map(x => x.name).join(', ') : undefined,
        minWidth: 160,
        filterable: false,
        sortable: false,
    },
    {
        title: 'میزان اهمیت',
        key: 'importances',
        exportValue: (item) => item.importances?.length ? item.importances.map(x => system.importances.find(y => y.id == x).name).join(', ') : undefined,
        minWidth: 160,
        filterable: false,
        sortable: false,
    },
    {
        title: 'وضعیت',
        key: 'status',
        value: (item) => item.status ? 'فعال' : 'غیر فعال',
        minWidth: 70,
    },
]);
const filters = ref({
    page: { type: 'hidden', label: 'صفحه', value: 1 },
    perPage: { type: 'hidden', label: 'تعداد آیتم در صفحه', value: 10 },
    keyword_based: { type: 'divider', label: 'بر اساس کلمه کلیدی', value: null },
    name: { type: 'text', label: 'عنوان', value: null },
    position_based: { type: 'divider', label: 'بر اساس شرایط اجرا قوانین', value: null },
    branches: { type: 'autocomplete', multiple: true, label: 'شعبه', items: system.branches, value: [], permission: auth.user.full_admin },
    departments: { type: 'autocomplete', multiple: true, label: 'دپارتمان', items: [], value: [] },
    workingshifts: { type: 'autocomplete', multiple: true, label: 'شیفت های کاری', items: [], value: [], permission: system.license.features.workingshift },
    ticketCategories: { type: 'autocomplete', multiple: true, label: 'دسته‌بندی‌های تیکت', items: system.ticketCategories, value: [] },
    customerLevels: { type: 'autocomplete', multiple: true, label: 'سطح مشتری', items: system.customerLevels, value: [] },
    importances: { type: 'autocomplete', multiple: true, label: 'میزان اهمیت', items: system.importances, value: [] },
    status_based: { type: 'divider', label: 'بر اساس وضعیت', value: null },
    status: { type: 'autocomplete', label: 'وضعیت', items: [{ name: 'فعال', id: '1' },{ name: 'غیرفعال', id: '0' }], value: null },
})
async function getList(finalFilters, cb = false) {
    loading.value = true;
    await api.slaList(finalFilters).then(async res => {
        if (res && res.status == "OK") {
            items.value = res.data;
            totalItems.value = res.total;
        }
    }).finally(() => loading.value = false);
    if (cb)
        cb();
}
async function getAllList(finalFilters) {
    let page = 1, data = [];
    while (page) {
        await api.slaList({
            ...finalFilters,
            perPage: 200,
            page: page,
        }).then(async res => {
            if (res && res.status == "OK") {
                data = data.concat(res.data);
                page = page == res.totalPages ? false : page + 1
            } else
                page = false;
        }).catch(() => page = false);
    }
    return data;
}
onBeforeMount(() => {
    system.setAdminDefaults().then(() => {
        filters.value.departments.items = system.departmentsAdmin
        filters.value.workingshifts.items = system.departmentsAdmin.map((x) => x.workingshifts).flat().filter((value, index, self) => self.findIndex(x=> x.id == value.id) >= index);
    });
});
</script>
